export const HealthMatchIcon = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="opacity-10"
  >
    <path
      d="M36.1801 35.8823C49.0001 35.2423 49.0001 23.0323 49.0001 23.0323V12.4423C48.9069 9.11074 47.518 5.94692 45.1287 3.62343C42.7393 1.29993 39.5379 0 36.2051 0C32.8722 0 29.6708 1.29993 27.2815 3.62343C24.8921 5.94692 23.5032 9.11074 23.4101 12.4423V23.0323H12.8001C11.1153 23.0336 9.44734 23.3672 7.8917 24.0141C6.33607 24.6609 4.92331 25.6083 3.73432 26.8019C2.54534 27.9955 1.60349 29.412 0.962709 30.9701C0.321928 32.5283 -0.00519881 34.1975 6.24689e-05 35.8823C0.0027109 39.2762 1.35213 42.5304 3.75202 44.9303C6.15191 47.3302 9.4061 48.6796 12.8001 48.6823H23.3901C23.3901 48.4823 23.2401 36.2723 36.1801 35.8823Z"
      fill="currentColor"
    />
    <path
      d="M38.3901 38.0423C25.5901 38.6323 25.5901 50.8823 25.5901 50.8823V61.4223C25.5901 64.817 26.9386 68.0728 29.3391 70.4732C31.7396 72.8737 34.9953 74.2223 38.3901 74.2223C41.7848 74.2223 45.0406 72.8737 47.441 70.4732C49.8415 68.0728 51.1901 64.817 51.1901 61.4223V50.8823H61.7801C63.4639 50.8823 65.1311 50.5498 66.6862 49.9039C68.2412 49.258 69.6534 48.3115 70.8417 47.1185C72.03 45.9255 72.9711 44.5097 73.6109 42.9521C74.2507 41.3946 74.5766 39.7261 74.5701 38.0423C74.5701 34.6492 73.2229 31.395 70.8246 28.9948C68.4263 26.5947 65.1731 25.2449 61.7801 25.2423H51.1901C51.0001 25.2423 51.1901 37.4523 38.3901 38.0423Z"
      fill="currentColor"
    />
  </svg>
);
